/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Product variant — controls entitlement requirement and publisher billing.
 */
export type ProductVariant = typeof ProductVariant[keyof typeof ProductVariant];


export const ProductVariant = {
  full: 'full',
  demo: 'demo',
  preview: 'preview',
} as const;
